import React, { useState } from 'react';
import AdminDashboard from './AdminDashboard';
import UserTable from './UserTable';

export default function SuperAdminPanel({ analytics, users, fetchUsers, token, userProfile }) {
  const [tab, setTab] = useState('dashboard');

  return (
    <div className="superadmin-panel" style={{padding:24}}>
      <div style={{display:'flex',gap:16,marginBottom:24}}>
        <button className={tab==='dashboard' ? 'tab-active' : ''} onClick={()=>setTab('dashboard')}>Dashboard</button>
        <button className={tab==='users' ? 'tab-active' : ''} onClick={()=>setTab('users')}>Usuários</button>
        <button className={tab==='profile' ? 'tab-active' : ''} onClick={()=>setTab('profile')}>Meu Perfil</button>
      </div>
      <div style={{background:'#fff',borderRadius:8,padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
        {tab === 'dashboard' && <AdminDashboard analytics={analytics} />}
        {tab === 'users' && <UserTable users={users} onCreate={fetchUsers.onCreate} onEdit={fetchUsers.onEdit} onDelete={fetchUsers.onDelete} />}
        {tab === 'profile' && (
          <div>
            <h3>Perfil do Administrador</h3>
            <p><b>Nome:</b> {userProfile?.name}</p>
            <p><b>Email:</b> {userProfile?.email}</p>
            <p><b>Função:</b> {userProfile?.role}</p>
            {/* Adicione mais campos se necessário */}
          </div>
        )}
      </div>
    </div>
  );
}
